import React from "react";

/**
 * NestedItemContent - A reusable component for content layout in nested items
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display
 * @param {string} props.className - Additional CSS classes
 */
const NestedItemContent = ({ children, className = "" }) => {
  return <div className={`flex-1 ${className}`}>{children}</div>;
};

export default NestedItemContent;
